<template>
	<modal size="large" @close="$emit('close')">
		<template #header>
			<span class="font-weight-bold"> Edit Order #{{ data.order_id }}</span>
		</template>
		<template #body>
			<div class="row">
				<div v-if="Object.keys(errorMessage).length > 0" class="alert alert-danger mt-3" style="width: 100%;">
					Harap isi semua bidang yang diperlukan.
				</div>
				<div class="col-12 col-sm-9">
					<Accordion v-for="form in forms" :key="form.key" :openFirst="form.isOpen">
						<template slot="heading"
							><b>{{ form.title }}</b></template
						>
						<template #body>
							<div class="row p-2">
								<div
									v-for="(i, key) in form.form"
									:key="key"
									class="col-12"
									:class="{
										'col-sm-6':
											key !== 'shipping' && key !== 'pickup_location_address',
									}"
								>
									<div
										class="row mt-4"
										v-if="
											form.form.show_detail &&
											form.form.show_detail.value &&
											key === 'shipping'
										"
									>
										<div
											v-for="(index, value) in form.form.shipping"
											:key="value"
											class="col-sm-6 mt-3"
										>
											<FormInput
												:form-key="value"
												:form.sync="form.form.shipping"
												:part-key="form.key"
												@on-change="onChangeShipping"
												:errorMessage="errorMessage"
											/>
										</div>
									</div>
									<FormInput
										v-else-if="key !== 'shipping'"
										:form="form.form"
										:form-key="key"
										:part-key="form.key"
										@on-change="onChange(form.form, key)"
										:errorMessage="errorMessage"
									/>
								</div>
							</div>
						</template>
					</Accordion>
				</div>
				<OrderSummary :data="data" :quantity.sync="forms[1].form.quantity" />
			</div>
		</template>
		<template #footer>
			<button class="btn btn-light btn-sm" style="font-size: 13px" @click="$emit('close')">
				Close
			</button>
			<button
				class="btn btn-primary btn-sm px-4"
				style="font-size: 13px"
				:class="{ 'is-loading': isSubmitLoad }"
				:disabled="disabledSave"
				@click="update"
			>
				Update Order
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Accordion from '@/components/Accordion.vue';
import FormInput from '@/components/private-orders/modal/form.vue';
import OrderSummary from './OrderSummary.vue';
import { duplicateVar } from '@/lib/helper';
import shippingApi from '@/api/shipping';

export default {
	name: 'EditOrder',
	components: {
		Modal,
		Accordion,
		FormInput,
		OrderSummary,
		// InputCheckbox,
	},
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		isSubmitLoad: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			forms: [
				{
					key: 'customer_name',
					title: 'Customer Name',
					isOpen: true,
					form: {
						name: '',
						phone: '',
						email: '',
						address: '',
						show_detail: {
							value: true,
							label: 'Edit Address Details',
						},
						shipping: {
							province: {
								value: null,
								options: [],
								loader: false,
							},
							city: {
								value: null,
								options: [],
								loader: false,
							},
							subdistrict: {
								value: null,
								options: [],
								loader: false,
							},
							zip: '',
						},
					},
				},
				{
					key: 'order_data',
					isOpen: true,
					title: 'Order Data',
					form: {
						quantity: 0,
						notes: '',
						payment_method: {
							value: null,
							options: [
								{
									key: 'bank_transfer',
									label: 'Bank transfer',
									$isDisabled: false,
								},
								{
									key: 'instant',
									label: 'Instant',
									$isDisabled: true,
								},
							],
						},
					},
				},
			],
			errorMessage: {},
		};
	},
	computed: {
		isFormValid() {
			// Reset error messages sebelum validasi
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.errorMessage = {};

			let valid = true;
			this.forms.forEach((formItem) => {
				if (!this.isValidObject(formItem.form)) {
					valid = false;
				}
			});
			return valid;
		},
		disabledSave() {
			return this.isSubmitLoad || !this.isFormValid;
		},
	},
	created() {
		if (this.data) {
			const formCustomer = duplicateVar(this.data.customer_data);
			const form = {
				...this.forms[0].form,
				name: formCustomer.name,
				phone: formCustomer.phone,
				email: formCustomer.email,
				address: formCustomer.address,
			};

			const orderDataForm = {
				...this.forms[1].form,
				quantity: Number(this.data?.customer_data.quantity) ?? 0,
				notes: formCustomer?.notes ?? '',
			};

			if (this.data.payment_info) {
				orderDataForm.payment_method.value = {
					key: this.data.payment_info,
					label: this.data.payment_info.replace(/_/g, ' ')
						.split(' ')
						.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
						.join(' '),
				};
			}

			if (formCustomer.province_name && formCustomer.province_id) {
				form.shipping.province.value = {
					key: formCustomer.province_id,
					label: formCustomer.province_name,
				};

				form.shipping.city.value = {
					key: formCustomer.city_id,
					label: formCustomer.city_name,
				};

				form.shipping.subdistrict.value = {
					key: formCustomer.subdistrict_id,
					label: formCustomer.subdistrict_name,
				};

				form.shipping.zip = formCustomer.zip ?? '';
			}

			this.forms[0].form = form;
			this.forms[1].form = orderDataForm;
		}
		this.getDataPrivince();

		if (this.forms[0].form.shipping.province.value.key) {
			this.getDataCity(this.forms[0].form.shipping.province.value.key);
		}

		if (this.forms[0].form.shipping.city.value.key) {
			this.getSubdistricts(this.forms[0].form.shipping.city.value.key);
		}
	},
	methods: {
		isValidObject(obj) {
			// eslint-disable-next-line no-restricted-syntax
			for (const key in obj) {
				// eslint-disable-next-line no-prototype-builtins
				if (obj.hasOwnProperty(key)) {
					const field = obj[key];
					if (key !== 'notes') {
						if (typeof field === 'object' && field !== null) {
							if ('value' in field) {
								if (
									field.value === ''
								|| field.value === null
								|| field.value === undefined
								) {
									this.setErrorMessage(
										key,
										`${this.getFieldLabel(key)} is required.`,
									);
									return false;
								}
							} else if (!this.isValidObject(field)) {
								return false;
							}
						} else if (field === '' || field === null || field === undefined) {
							this.setErrorMessage(key, `${this.getFieldLabel(key)} is required.`);
							return false;
						}
					}
				}
			}
			return true;
		},
		setErrorMessage(key, message) {
			this.$set(this.errorMessage, key, message);
		},
		clearErrorMessage(key) {
			this.$delete(this.errorMessage, key);
		},
		getFieldLabel(key) {
			const labels = {
				name: 'Customer Name',
				phone: 'Phone',
				email: 'Email',
				address: 'Address',
				province: 'Province',
				city: 'City',
				subdistrict: 'Subdistrict',
				zip: 'ZIP Code',
				quantity: 'Quantity',
				notes: 'Notes',
				payment_method: 'Payment Method',
			};
			return labels[key] || key;
		},
		getDataPrivince() {
			const callback = (res) => {
				const provinces = res?.data;

				this.forms[0].form.shipping.province.options = provinces.map(province => ({
					key: province.province_id,
					label: province.province_name,
				}));
			};
			const err = e => console.log(e);
			shippingApi.getAllProvinces(callback, err);
		},
		getDataCity(provinceId) {
			const params = {
				province_id: provinceId,
			};
			const callback = (res) => {
				this.forms[0].form.shipping.city.loader = false;
				const cities = res?.data;

				this.forms[0].form.shipping.city.options = cities.map(province => ({
					key: province.city_id,
					label: province.city_name_with_type,
				}));
			};
			const err = e => console.log(e);
			shippingApi.getCities(params, callback, err);
		},
		getSubdistricts(cityId) {
			const callback = (res) => {
				const subdistricts = res?.data;

				this.forms[0].form.shipping.subdistrict.options = subdistricts.map(
					subdistrict => ({
						key: subdistrict.subdistrict_id,
						label: subdistrict.subdistrict_name,
						zip: subdistrict.zip,
					}),
				);

				this.forms[0].form.shipping.subdistrict.loader = false;
			};
			const err = e => console.log(e);
			shippingApi.getSubdistricts(cityId, callback, err);
		},
		onChange(value, key) {
			const index = this.forms.findIndex(curr => curr?.key === key);

			if (index !== -1) {
				this.forms[index].form = value;
				if (value[key] !== '' && value[key] !== null && value[key] !== undefined) {
					this.clearErrorMessage(key);
				}
			}
		},
		onChangeShipping(value, accordionKey, formKey) {
			if (formKey === 'province') {
				this.getDataCity(value.province?.value?.key);
				this.forms[0].form.shipping.city.loader = true;
				// Reset
				this.forms[0].form.shipping.city.value = null;
				this.forms[0].form.shipping.subdistrict.value = null;
				this.forms[0].form.shipping.zip = null;
				this.clearErrorMessage('province');
				this.clearErrorMessage('city');
				this.clearErrorMessage('subdistrict');
				this.clearErrorMessage('zip');
			} else if (formKey === 'city') {
				this.getSubdistricts(value.city.value.key);
				this.forms[0].form.shipping.subdistrict.loader = true;
				this.forms[0].form.shipping.subdistrict.value = null;
				this.clearErrorMessage('city');
				this.clearErrorMessage('subdistrict');
			} else if (formKey === 'subdistrict') {
				this.forms[0].form.shipping.zip = this.forms[0].form.shipping.subdistrict.value.zip;
			}
		},
		update() {
			if (this.isFormValid) {
				this.$emit('submit', this.forms, 'edit_order');
			} else {
				console.error('Form tidak valid. Silakan periksa kembali.');
			}
		},
	},
};
</script>
